import React, {useState} from 'react';
import { Form, Input, Button , Select, Divider, Col, Row, DatePicker } from 'antd';
import { useFirestore } from 'reactfire';

import moment from 'moment';
import { Redirect } from 'react-router-dom';
import { useEffect } from 'reactn';

const PatientForm = (props) => {

    const { Option } = Select;
    const { TextArea } = Input;
    const [redirect, setRedirect] = useState(false);
    const [editMode, setEditMode] = useState();
    const [form] = Form.useForm();
    const firestore = useFirestore();
    const query = firestore.collection("patients");

    const [loadingBtn, setLoadingBtn] = useState(false);
  

    // console.log(firestore, query);
    // const

    useEffect(() => {
        setEditMode(props.type === "Edit" ? true: false);
        // console.log(props.patient);
        form.setFieldsValue({
            fullName: props.patient && props.patient.fullName,
            guardianName: props.patient && props.patient.guardianName,
            education: props.patient && props.patient.education,
            nationality: props.patient && props.patient.nationality,
            contactNumber: props.patient && props.patient.contactNumber,
            gender: props.patient && props.patient.gender,
            DOB: props.patient && props.type === "Edit" ? (props.patient.DOB ? moment(props.patient.DOB) : '') : '',
            occupation: props.patient && props.patient.occupation,
            address: props.patient && props.patient.address,
            note: props.patient && props.patient.note,
            MedicalHistory: props.patient && props.patient.MedicalHistory,
            PastSugicalHistory: props.patient && props.patient.PastSugicalHistory,
            PersonalHistory: props.patient && props.patient.PersonalHistory,
            AddictionHistory: props.patient && props.patient.AddictionHistory,
            HistoryofanyDrugAllergy: props.patient && props.patient.HistoryofanyDrugAllergy,
            FamilyHistory: props.patient && props.patient.FamilyHistory,


        });
        console.log(props.patient && props.patient.DOB);
    }, [props, form])

    const layout = {
        labelCol: { span: 0 },
        wrapperCol: { span: 24 },
    };

    const onFinish = values => {
        // API.post(`patients`, values).then((response) => {
        //     setRedirect(true);    
        // });
        setLoadingBtn(true);
        values.DOB = values.DOB.toString();
        values.date = new Date();
        Object.keys(values).forEach(key => values[key] === undefined && delete values[key]);
        query.add(values).then(() => {
            setRedirect(true); 
            setLoadingBtn(false);
        });
        
        // firebase.child('patients').push(values);
    };

    const onFinishEdit = values => {
        setLoadingBtn(true);
        // values.DOB = values.DOB.toDate();
        values.DOB = values.DOB.toString();
        values.date = new Date();
        Object.keys(values).forEach(key => values[key] === undefined && delete values[key]);
        query.doc(props.patientID).update(values).then((response) => {
            setRedirect(true);  
            setLoadingBtn(false);  
        });
        // API.put(`patients/${props.patient._id}`, values).then((response) => {
        //     setRedirect(true);    
        // });
    };
    
      const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
      };

      const tailLayout = {
        wrapperCol: { offset: 0, span: 24 },
    };


    return (
        <Form
            {...layout}
            form={form}
            layout="vertical"
            name="basic"
            initialValues={{ remember: true }}
            onFinish={editMode ? onFinishEdit : onFinish}
            onFinishFailed={onFinishFailed}
            >

            {redirect ? <Redirect to="/patients" /> : ''  }

            <Row gutter={20}>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        label="Full Name"
                        name="fullName"
                        rules={[{ required: true, message: 'Please input your Full Name' }]}
                    >
                        <Input size="large" />
                    </Form.Item>
                    <Form.Item
                        label="Guardian Name"
                        name="guardianName"
                    >
                        <Input size="large" />
                    </Form.Item>
                    <Form.Item
                        label="Education"
                        name="education"
                    >

                    {/* <AutoComplete
                        style={{ width: 200 }}
                        options={options}
                        placeholder="try to type `b`"
                    /> */}

                        <Select placeholder="Select Qualification" size="large">
                            <Option value="Illiterate">Illiterate</Option>
                            <Option value="0 - Early Childhood Education">0 - Early childhood education</Option>
                            <Option value="1 - Primary education">1 - Primary education</Option>
                            <Option value="2 - Lower secondary education">2 - Lower secondary education</Option>
                            <Option value="3 - Upper secondary education">3 - Upper secondary education</Option>
                            <Option value="4 - Post-secondary non-tertiary education">4 - Post-secondary non-tertiary education</Option>
                            <Option value="5 - Short-cyclc tertiary education">5 - Short-cyclc tertiary education</Option>
                            <Option value="6 - Bachlor's or equivalent level">6 - Bachlor's or equivalent level</Option>
                            <Option value="7 - Master's or equivalent level">7 - Master's or equivalent level</Option>
                            <Option value="8 - Doctoral or equivalent level">8 - Doctoral or equivalent level</Option>
                            <Option value="9 - Not elsewhere classified">9 - Not elsewhere classified</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Nationality"
                        name="nationality"
                    >
                        <Select defaultValue="pakistani" placeholder='Pakistani' size="large">
                            <Option value="pakistani">Pakistani</Option>
                            <Option value="others">Others</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        label="Contact Number"
                        name="contactNumber"
                        rules={[{ required: true, message: 'Please input your Contact Number' }]}
                    >
                        <Input size="large" />
                    </Form.Item>
                    <Form.Item
                        label="Gender"
                        name="gender"
                    >
                        <Select placeholder="Gender" size="large">
                            <Option value="Male">Male</Option>
                            <Option value="Female">Female</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Date of Birth"
                        name="DOB"
                    >
                        <DatePicker size="large"  format='DD/MM/YYYY' />
                    </Form.Item>

                    <Form.Item
                        label="Occupation"
                        name="occupation"
                        >
                        <Select mode="tags" style={{ width: '100%' }} placeholder="Select Occupation" size="large">
                            <Option value="Student">Student</Option>
                            <Option value="Hwife">H.Wife</Option>
                            <Option value="UnEmployed">Un-employed</Option>
                            <Option value="Shopkeeper">Shopkeeper</Option>
                            <Option value="Teacher">Teacher</Option>
                            <Option value="Professional">Professional</Option>
                            <Option value="Businessman">Businessman</Option>
                            <Option value="Gov-Employee">Gov-Employee</Option>
                            <Option value="Non Gov-Employee">Non Gov-Employee</Option>
                        </Select>
                    </Form.Item>

                    {/* <Form.Item
                        label="Occupation"
                        name="occupation"
                    >
                        <Select placeholder="Select Occupation" size="large">
                            <Option value="Student">Student</Option>
                            <Option value="Hwife">H.Wife</Option>
                            <Option value="UnEmployed">Un-employed</Option>
                            <Option value="Shopkeeper">Shopkeeper</Option>
                            <Option value="Teacher">Teacher</Option>
                            <Option value="Professional">Professional</Option>
                            <Option value="Businessman">Businessman</Option>
                            <Option value="Other">Other..</Option>
                        </Select>
                    </Form.Item> */}
                    
                </Col>
                
            </Row>
            <Form.Item
                        label="Address"
                        name="address"
                    >
                        <Input size="large" />
                    </Form.Item>

            <Form.Item
            label="Past Medical History"
            name="MedicalHistory"
            >
            <Select mode="tags" style={{ width: '100%' }} placeholder="Please Select Diseases">
                    <Option value="NAD (NIL)">NAD (NIL)</Option>
                    <Option value="Diabetes Mellitus">Diabetes Mellitus</Option>
                    <Option value="Ischemic Heart Disease">Ischemic Heart Disease</Option>
                    <Option value="Hypertension (HTN)">Hypertension (HTN)</Option>
                    <Option value="Stroke (CVA)">Stroke (CVA)</Option>
                    <Option value="Tuberculosis">Tuberculosis</Option>
                    <Option value="Asthma">Asthma</Option>
                    <Option value="COPD">COPD</Option>
                    <Option value="Peptic Ulcer">Peptic Ulcer</Option>
                    <Option value="Hepatitis B">Hepatitis B</Option>
                    <Option value="Hepatitis C">Hepatitis C</Option>
                    <Option value="HIV/AIDS">HIV/AIDS</Option>
                    <Option value="Renal Failure">Renal Failure</Option>
                    <Option value="Hepatic Failure">Hepatic Failure</Option>
                    <Option value="Any Cancer">Any Cancer</Option>
                    <Option value="Radiation Exposure">Radiation Exposure</Option>

            </Select>
            </Form.Item>

            <Form.Item
            label="Past Sugical History"
            name="PastSugicalHistory"
            >
            <Select mode="tags" style={{ width: '100%' }} placeholder="Please Select">
                    <Option value="NAD (NIL)">NAD (NIL)</Option>
            </Select>
            </Form.Item>

            <Form.Item
            label="Personal History"
            name="PersonalHistory"
            >
            <Select mode="tags" style={{ width: '100%' }} placeholder="Please Select">
                    <Option value="Single">Single</Option>
                    <Option value="Married">Married</Option>
                    <Option value="Widow">Widow</Option>
                    <Option value="Divorced">Divorced</Option>
            </Select>
            </Form.Item>

            <Form.Item
            label="Addiction History"
            name="AddictionHistory"
            >
            <Select mode="tags" style={{ width: '100%' }} placeholder="Please Select">
                    <Option value="Nil">Nil</Option>
                    <Option value="Smoker">Smoker</Option>
                    <Option value="Niswar Addict">Niswar Addict</Option>
                    <Option value="Pan/Chalia/Tobacco Addict">Pan/Chalia/Tobacco Addict</Option>
                    <Option value="Alcohol Addict">Alcohol Addict</Option>
            </Select>
            </Form.Item>
            <Form.Item
            label="History of any Drug Allergy"
            name="HistoryofanyDrugAllergy"
            >
            <Select mode="tags" style={{ width: '100%' }} placeholder="Please Select">
                    <Option value="NAD (NIL)">NAD (NIL)</Option>
            </Select>
            </Form.Item>

            <Form.Item
            label="Family History"
            name="FamilyHistory"
            >
            <Select mode="tags" style={{ width: '100%' }} placeholder="Please Select">
                    <Option value="NAD (NIL)">NAD (NIL)</Option>
            </Select>
            </Form.Item>

            <Form.Item
                    label="Note"
                    name="note"
                >
                    <TextArea rows={2} />
                </Form.Item>

                

            <Form.Item {...tailLayout}>
                <Button type="primary" loading={loadingBtn} htmlType="submit">
                Submit
                </Button>
            </Form.Item>
        </Form>
    );
}

export default PatientForm;
